import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import styled from "styled-components";

export const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))`
  & .${tooltipClasses.tooltip} {
    background-color: #7d6e7294;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    border-radius: 12px;
    padding: 8px 12px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
    text-align: center;
    transition: all 0.2s ease-in-out;
    .MuiTooltip-arrow {
      display: none;
      &::before: {
        background-color: white;
      }
    }
  }
`;
